import React from "react";
import NavIcon from "../images/nav_icon.svg";
import NavClose from "../images/nav_close.svg";
import { trackEvent } from "../utils/analytics";

const MobileNav = (props) => {
    const { mobileNavOpen, menuContent, toggleMobileNav } = props;

    // 埋設 GA 點擊 Navbar 按鈕傳送參數
    const sendGaEventNavbar = (e) => {
        trackEvent("event", "Click", {
            "event_category": "Sheet",
            "event_label": e.currentTarget.dataset.label,
            "value": 1
        });
    };

    // 埋設 GA 點擊 2022 潮味台南按鈕傳送參數
    const sendGaEvent2022Tainan = (e) => {
        trackEvent("event", "Click", {
            "event_category": "2022Chill",
            "event_label": "2022Chill_click",
            "value": 1
        });
    };

    return (
        <section className={`mobileNav ${mobileNavOpen ? "open" : ""}`}>
            <ul>
                {
                    menuContent.map((item, i) => (
                        <li className="menu-item" key={item.id}>
                            <a
                                href="/"
                                onClick={(e) => {
                                    let element = document.getElementById(item.id);
                                    e.preventDefault();
                                    toggleMobileNav();
                                    element && element.scrollIntoView({ behavior: "smooth", block: "start" });
                                    sendGaEventNavbar(e);
                                }}
                                data-label={`Sheet${i + 1}_click`}
                                rel="noreferrer"
                            >
                                {item.title}
                            </a>
                        </li>
                    ))
                }
                <li className="menu-item">
                    <a
                        href="https://chill-tainan2022.events.pixnet.net/"
                        target="_blank"
                        onClick={sendGaEvent2022Tainan}
                        rel="noreferrer"
                    >
                        潮Way台南
                    </a>
                </li>
            </ul>
            <div className="nav-control">
                {mobileNavOpen ?
                    <img
                        className="nav-close"
                        onClick={toggleMobileNav}
                        src={NavClose}
                        width={24}
                        height={24}
                        alt="nav_close"
                    />
                    :
                    <img
                        className="nav-icon"
                        onClick={toggleMobileNav}
                        src={NavIcon}
                        width={24}
                        height={24}
                        alt="nav_icon"
                    />
                }
            </div>
        </section>
    );
};

export default MobileNav;
